import vClickOutside from 'v-click-outside';

export default (Vue) => {
    Vue.use(vClickOutside);
};
